module.exports = __webpack_public_path__ + "img/公众号@2x.da49c55f.png";